import { createStore } from "redux";
import rootReducer from "./reducers";

// Create the store shared in full App
export default createStore(rootReducer);
